import { produce } from "immer";
import { normalizeUnitId } from "../../utils/property.util";
import ACTIONS from "../actions/types.actions";

const building = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.BUILDING_REQUEST:
      draft[action.key] = !draft[action.key];
      return draft;
    case ACTIONS.BUILDING_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.selected = action.response;
      return draft;
    case ACTIONS.BUILDING_CODE_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.codeDetail = action.response;
      return draft;
    case ACTIONS.BUILDING_PUBLISHED_UNITS_SUCCESS:
      draft.publishedUnits = action.response;
      return draft;
    case ACTIONS.BUILDING_UOM_SUCCESS:
      draft.uom = action.response;
      return draft;
    case ACTIONS.BUILDING_TOTAL_BUILDING_SIZE_SUCCESS:
      draft.totalBuildingSize = action.response;
      return draft;
    case ACTIONS.BUILDING_OCCUPIED_SPACE_SUCCESS:
      draft.spaceOccupiedByUnits = action.response;
      return draft;
    case ACTIONS.BUILDING_ERROR:
      draft.loading = false;
      draft.auditLoading = false;
      draft.usersLoading = false;
      draft.error = action.error;
      return draft;
    case ACTIONS.BUILDING_COMBINED_UNIT_NUMBER:
      draft.maxCombinedUnitNumber = action.maxCombinedUnitNumber;
      return draft;
    case ACTIONS.BUILDING_UNIT_DETAIL_SUCCESS:
      // Subsequent property saves must use the latest individual publication states.
      if (Array.isArray(action.response.source) && action.response.source.length && draft.selected?.unitInfo) {
        const updatedIds = new Set(action.response.source.map(unit => normalizeUnitId(unit.unitId)));
        const previousGroups = new Set(
          draft.selected.unitInfo
            .filter(unit => updatedIds.has(normalizeUnitId(unit.unitId)))
            .map(unit => unit.ghostUnitCode)
            .filter(Boolean),
        );
        draft.selected.unitInfo = draft.selected.unitInfo
          .filter(unit => !updatedIds.has(normalizeUnitId(unit.unitId)) && !previousGroups.has(unit.ghostUnitCode))
          .concat(action.response.source);
      }
      draft.unitDetail = action.response;
      draft.loading = false;
      return draft;
    case ACTIONS.GET_MARKET_USERS_SUCCESS:
      draft.usersLoading = false;
      draft.error = null;
      return draft;
    default:
      return draft;
  }
});

export default building;
